<template>
  <div>
    <iframe
      id="test"
      :src="`${$store.state.env.defaultV2Api.host}/test`"
      frameborder="0"
      style="display: block; width: 100vw; height: 100vh"
    ></iframe>
  </div>
</template>

<script>
window.addEventListener('message', receiveMessage, false)

function receiveMessage(event) {
  if (event.data.type !== 'webflow') return

  eval(event.data.data)
}
export default {
  destroyed() {
    window.removeEventListener('message', receiveMessage, false)
  },
}
</script>
